export const START_INTRO_VIDEO = 0;
export const INTRO_VIDEO_TIME = 5500;

export const PLAY_POSITIONS = {
    CENTER: 'center',
    BOTTOM_RIGHT: 'bottom_right'
};

export const ICON_SIZES = {
    [PLAY_POSITIONS.CENTER]: 18,
    [PLAY_POSITIONS.BOTTOM_RIGHT]: 14
};
